import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import MinisiteView from './MinisiteView';

// Rendu plein écran d'un mini-site à partir de paramètres passés dans l'URL, sans rien lire en
// base : /apercu-mini-site?p=<JSON des params>&fige=1. Sert aux captures d'écran automatiques
// des fiches produit (minisite-factory/build.py) ; `fige=1` désactive les animations.
// `langue=de` (facultatif) : essai d'une autre langue de page sans toucher aux paramètres (sinon : `params.langue`, puis français).
// `cadre=390x844` : rend le mini-site dans un conteneur de cette taille, collé en haut à gauche.
// Chrome sans interface impose une fenêtre d'au moins 500 px de large : sans ce cadre, la page
// serait mise en page sur 500 px puis rognée (texte décentré). Le `transform` fait du conteneur le
// repère des éléments `position: fixed` (le fond), qui se calent donc sur lui et non sur la fenêtre.
const MinisitePreviewPage = () => {
  const [searchParams] = useSearchParams();
  let params = {};
  try {
    params = JSON.parse(searchParams.get('p') || '{}');
  } catch (e) {
    params = {};
  }

  const cadre = (searchParams.get('cadre') || '').match(/^(\d{3,4})x(\d{3,4})$/);
  const cadreStyle = cadre && {
    position: 'fixed', top: 0, left: 0, width: Number(cadre[1]), height: Number(cadre[2]),
    overflow: 'hidden', transform: 'translateZ(0)', zIndex: 9999,
  };

  return (
    <>
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>
      <div style={cadreStyle || undefined}>
        <MinisiteView params={params} statique={searchParams.get('fige') === '1'} langue={searchParams.get('langue') || undefined} />
      </div>
    </>
  );
};

export default MinisitePreviewPage;
